import * as React from "react";

import { cn } from "@/lib/utils";

export interface PageHeaderProps {
  title: string;
  description?: string;
  breadcrumb?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}

/**
 * Page H1 region: optional breadcrumb, title, description, and primary action (ascension-plan §2.2).
 * NOTE: eyebrow labels are intentionally not supported — design direction is no eyebrow elements anywhere.
 */
export function PageHeader({
  title,
  description,
  breadcrumb,
  action,
  className,
}: PageHeaderProps) {
  return (
    <header className={cn("space-y-4", className)}>
      {breadcrumb ? <div className="text-sm text-muted-foreground">{breadcrumb}</div> : null}

      <div className="flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
        <div className="min-w-0 space-y-2">
          <h1 className="font-display text-4xl font-bold tracking-tight text-foreground md:text-5xl">{title}</h1>
          {description ? <p className="max-w-2xl text-base text-muted-foreground">{description}</p> : null}
        </div>

        {action ? (
          <div className="flex shrink-0 flex-wrap items-center gap-2 md:justify-end">{action}</div>
        ) : null}
      </div>
    </header>
  );
}
